var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { attrs: { id: "section-proficiency" } },
    [
      _c(
        _setup.MainSectionPanel,
        [
          _c("div", { class: ["w-100", "d-flex", "align-items-stretch"] }, [
            _c("div", { staticClass: "rotating-icons" }, [
              _c(
                "div",
                { staticClass: "icon-rotator" },
                _vm._l(_setup.ROTATING_ICON, function ({ key, icon }) {
                  return _c(
                    "div",
                    { key: key, class: ["rotating-icon", `icon-${key}`] },
                    [
                      _c("div", { staticClass: "icon-origin" }, [
                        _c(
                          "div",
                          { staticClass: "icon-inner" },
                          [_c("Icon", _vm._b({}, "Icon", { icon }, false))],
                          1
                        ),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(_setup.FeatureDetailsBlock, {
            attrs: {
              title: "Shorten Time to Proficiency",
              details:
                "Fly without risking hardware, having to charge drone batteries, and worrying about weather. Users can train wherever and whenever they want.",
              justification: "right",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(_setup.ParallaxWrapper, { attrs: { factor: -0.05 } }, [
        _c(
          "div",
          { staticClass: "shape-container" },
          [
            _c("div", { staticClass: "shape-a" }),
            _vm._v(" "),
            _c(_setup.ParallaxWrapper, { attrs: { factor: -0.05 } }, [
              _c("div", { staticClass: "shape-b" }),
            ]),
            _vm._v(" "),
            _c(_setup.ParallaxWrapper, { attrs: { factor: -0.08 } }, [
              _c("div", { staticClass: "shape-c" }),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }